module.exports = __webpack_public_path__ + "img/76272.ad3946b2.svg";